import EventNoteDetail from '@/screens/EventNoteDetail';

export default function PrivateEventEventIdNotesIndexRoute() {
  return <EventNoteDetail />;
}
